import { OrganizationRoute } from "#src/routes/organization";
import { RoutePath } from "#src/utils/route";

export const EquipmentListRoute = OrganizationRoute.concat(
  new RoutePath({
    path: "/equipment",
    title: "Equipment",
  })
);

// Declared here instead of ../create to prevent circular dependency
export const EquipmentCreateRoute = EquipmentListRoute.concat(
  new RoutePath<"mode">({
    path: "/create/:mode",
    title: "Create Equipment",
  })
);

export const EquipmentDetailRoute = EquipmentListRoute.concat(
  new RoutePath<"equipmentId", "tab">({
    title: "Equipment Details",
    path: "/:equipmentId/detail",
  })
);

export const EquipmentRecordDetailRoutePath = EquipmentDetailRoute.concat(
  new RoutePath<"recordId">({
    title: "Equipment Record Details",
    path: "/record-details/:recordId",
  })
);

export const EquipmentRecordValueDetailRoutePath =
  EquipmentRecordDetailRoutePath.concat(
    new RoutePath<"measurementType">({
      path: "/value/:measurementType",
      title: "Equipment Record Value Details",
    })
  );

export const EquipmentRecordValueSourceRoutePath =
  EquipmentRecordValueDetailRoutePath.concat(
    new RoutePath({
      path: "/configure",
      title: "Add Record Value Source",
    })
  );

/** @deprecated directly declaring and referencing this breadcrumb is unnecessary. Use new RoutePath based pattern and directly generate breadcrumbs using 'useBreadcrumbsFromRoute()' hook */
export const EQUIPMENT_LIST_BREADCRUMB = EquipmentListRoute.toBreadcrumb();

export * from "./EquipmentListPage";
